<div class="tooltipContainer">
    <icon style="padding-left:3px" icon="'info'" title="" [popover]="popTemplate" [containerClass]="'popoverContainer'" popover-placement="right" triggers="mouseenter:mouseleave"></icon>
    <ng-template #popTemplate>
        <h6 translate="{{ titleKey }}"></h6>
        <p [innerHTML]="contentKey | translate"></p>
    </ng-template>
</div>